import { ArrowRightOutlined, CalendarOutlined, CloseOutlined, LeftOutlined, MailFilled, NotificationOutlined, RightOutlined, CheckCircleFilled, TeamOutlined, ClockCircleFilled, UserOutlined, LoginOutlined, ContainerFilled, EnvironmentOutlined, DownOutlined, PlusOutlined } from '@ant-design/icons';
import { Avatar, Badge, Button, Calendar, Carousel, Col, Collapse, ConfigProvider, DatePicker, Flex, Image, Modal, Popover, Row, Space, Tree, Typography, Progress, Tag, List, Card, Segmented, Empty } from 'antd';
import en from 'antd/es/date-picker/locale/en_US';
import enUS from 'antd/es/locale/en_US';
import thTH from 'antd/es/locale/th_TH';
import { Input } from 'antd/lib';
import { Alert } from 'components/elements';
import dayjs from 'dayjs';
import { getEmployeeWorkInCount, getEmploymentInformation, getWorkIn, getEmployeeWorkingCountReport, getEmployeeWorkingDetailReport, getSubOrdinateVisaWorkPermitInfo, getCompanyVisaWorkPermitInfo, saveMemo, getMemo } from 'features/employee/services/employeeApi';
import { setCurrentEmploymentHome, setEmployeeWorkInCount, setIsLoading, setWorkinCalendarHome, setTeamWorkingCount, setTeamWorkingDetail, setTeamVisaWorkPermit } from 'features/employee/slices/employeeSlice';
import { getAnnouncementNewsPaging } from 'features/newAndPolicy/services/newsApi';
import { setNewsList } from 'features/newAndPolicy/slices/newsSlice';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from 'react-responsive';
import { useNavigate } from "react-router-dom";
import { generateRandomString } from 'utils/helper';
import Early from "../../../assets/images/early.svg";
import { WarningOutlined, ClockCircleOutlined, EditOutlined, FileTextOutlined } from '@ant-design/icons';
import Late from "../../../assets/images/late.svg";
import * as services from "../../newAndPolicy/services/policyApi";
import { setPolicyCategory } from "../../newAndPolicy/slices/policySlice";
import styles from "../styles/CardInfo.module.css";
import '../styles/importCss.css';
import useEmployeeWorkInCalendar from "features/employee/hooks/useEmployeeWorkInCalendar";
import SupervisorRequestOtModal from "features/employee/components/SupervisorRequestOtModal";
import HomeDayRequestModal from '../components/HomeDayRequestModal';
import { Dropdown } from 'antd';

const { Paragraph, Text } = Typography;
const CALENDAR_SCALE = 0.82;
function useCardInfo() {
    const isTabletOrMobile = useMediaQuery({ maxWidth: 1224 })
    const isOver = useMediaQuery({ maxWidth: 1000 })
    const [segmented, setSegmented] = useState("news");
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [currentDate, setCurrentDate] = useState(dayjs());
    const [selectedDetailDate, setSelectedDetailDate] = useState(null);
    const { currentCompany, currentEmployee } = useSelector((state) => state.company);
    const { currentEmploymentHome, employeeWorkInCount, calendarStartDate, calendarEndDate, workinCalendarHome } = useSelector((state) => state.employee);
    const { t, i18n } = useTranslation();
    const { roles } = useSelector((state) => state.company);
    const { newsList } = useSelector((state) => state.news);
    const { policyCategory } = useSelector((state) => state.policy);
    const [pagination, setPagination] = useState({ page: 1, size: 5 });
    const [total, setTotal] = useState(0);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedPolicy, setSelectedPolicy] = useState(null);
    const [openNote, setOpenNote] = useState({ open: false })
    const [year, setYear] = useState(dayjs().year())
    const [startDate, setStartDate] = useState(calendarStartDate || dayjs().startOf('month').format("YYYY-MM-DD"));
    const [endDate, setEndDate] = useState(calendarEndDate || dayjs().endOf('month').format("YYYY-MM-DD"));
    const { profile } = useSelector((state) => state.login);
    const [nowClock, setNowClock] = useState(dayjs());
    const [noteValue, setNoteValue] = useState('');
    const [noteSavedValue, setNoteSavedValue] = useState('');
    const [noteLoading, setNoteLoading] = useState(false);
    const [noteSaving, setNoteSaving] = useState(false);
    const [viewDate, setViewDate] = useState(dayjs());
    const {
        isModalOpen: isRequestModalOpen,
        setIsModalOpen: setIsRequestModalOpen,
        onSubmitSupRequest,
        onSubmitOffSiteWork,
        onSubmitLeave,
        onSubmitEditWorkTime,
        workTypeOptions,
        leaveGroupOptions,
        onAttachFileChange,
        setpreviousFilew,
        editTimeAtt,
    } = useEmployeeWorkInCalendar();
    const [initialRequestForm, setInitialRequestForm] = useState(null);
    const isHr = useMemo(() => roles?.includes("ROLE_HR"), [roles]);
    const openRequestModal = useCallback((formType) => {
        setInitialRequestForm(formType);
        setIsRequestModalOpen(true);
    }, [setIsRequestModalOpen]);
    function UseClock() {
        const [currentTime, setCurrentTime] = useState(dayjs());

        useEffect(() => {
            const timerId = setInterval(() => {
                setCurrentTime(dayjs()); // Update the time every second
            }, 1000);

            return () => clearInterval(timerId);
        }, []);

        return (
            <Space direction='vertical' style={{
                textAlign: 'left',
                // alignContent: "right"
                // color: "azure"
            }}>
                <h1>{currentTime?.format("HH:mm:ss")}</h1>
                <h4 >{currentTime?.format(i18n.language === "en" ? "dddd DD MMMM YYYY " : "dddd DD MMMM BBBB ") + t("week") + " " + getWeekOfMonth(currentTime)}</h4>
            </Space>)
    }

    useEffect(() => {
        const timer = setInterval(() => setNowClock(dayjs()), 1000 * 30);
        return () => clearInterval(timer);
    }, []);
    const getCellStyle = useCallback((entry) => {
        if (!entry) return { bg: "transparent", fg: "inherit" };
        const meta = getStatusColorMeta(entry);
        return { bg: meta.bg, fg: meta.fg };
    }, []);
    const getWeekOfMonth = (date) => {
        const startWeekDayIndex = date?.startOf('month').day(); // or date.day() for the first day of the week
        const currentDay = date?.date();
        return Math.ceil((currentDay + startWeekDayIndex) / 7);
    };

    const loadingRef = useRef(false);
    useEffect(() => {
        if (!selectedDetailDate || !currentCompany || !currentEmployee) {
            setNoteValue('');
            setNoteSavedValue('');
            return;
        }

        let cancelled = false;
        const fetchMemo = async () => {
            setNoteLoading(true);
            try {
                const res = await getMemo({
                    requestId: generateRandomString(),
                    companyId: currentCompany,
                    employeeId: currentEmployee,
                    date: selectedDetailDate.format('YYYY-MM-DD'),
                });
                if (!cancelled) {
                    const memoText = res?.data?.memo ?? '';
                    setNoteValue(memoText);
                    setNoteSavedValue(memoText);
                }
            } catch (error) {
                if (!cancelled) {
                    setNoteValue('');
                    setNoteSavedValue('');
                }
            } finally {
                if (!cancelled) setNoteLoading(false);
            }
        };

        fetchMemo();
        return () => { cancelled = true; };
    }, [selectedDetailDate, currentCompany, currentEmployee]);

    const onCancelNote = useCallback(() => {
        setNoteValue(noteSavedValue);
    }, [noteSavedValue]);

    const onConfirmNote = useCallback(async () => {
        if (!selectedDetailDate) return;
        setNoteSaving(true);
        try {
            await saveMemo({
                requestId: generateRandomString(),
                companyId: currentCompany,
                employeeId: currentEmployee,
                actionId: currentEmployee,
                date: selectedDetailDate.format('YYYY-MM-DD'),
                memo: noteValue,
            });
            setNoteSavedValue(noteValue);
        } catch (error) {
            Alert({ type: 'error', resultObject: error });
        } finally {
            setNoteSaving(false);
        }
    }, [selectedDetailDate, currentCompany, currentEmployee, noteValue]);

    const isNoteDirty = noteValue !== noteSavedValue;
    const getNewsList = useCallback(async (params = {}) => {
        if (loadingRef.current) return;

        loadingRef.current = true;
        try {
            dispatch(setIsLoading(true));
            // pagination.page = pagination.page - 1
            const response = await getAnnouncementNewsPaging({
                page: 0,
                size: 5,
                ...params,
                requestId: generateRandomString(),
                companyId: currentCompany,
                employee: currentEmployee,
            });
            dispatch(setNewsList(response?.data?.content || []));
            setTotal(response?.data?.totalItems)
        } catch (error) {
            // Alert({ type: "error", resultObject: error });
        } finally {
            loadingRef.current = false;
        }
    }, [currentCompany, currentEmployee]);

    useEffect(() => {
        // if (currentCompany && roles.length != 0) {
        if (roles.includes("ACCESS_NEWS_&_POLICY|NEWS")) {
            getNewsList({})
        }
        // }
    }, [currentCompany, getNewsList, pagination, roles])

    const dataSource = useMemo(
        () => {
            if (newsList) {
                const data = newsList?.map((data, i) => {
                    return (
                        {
                            title: data?.subject,
                            avatar: createImageUrl(data?.cover, "image/png"),
                            description:
                                data?.description,
                            startAnnounce: data?.startAnnounce,
                            announcementBy: data?.announcementBy["name" + (i18n.language == "en" ? "En" : "")],
                        })
                }
                );
                return data;
            } else {
                return []
            }
        }
        , [newsList, i18n.language])

    useEffect(() => {
        const removeTitleAttributes = () => {
            document.querySelectorAll(".ant-picker-cell").forEach((el) => {
                el.removeAttribute("title");
            });
        };

        removeTitleAttributes(); // ลบตอนแรก
        const observer = new MutationObserver(removeTitleAttributes);
        observer.observe(document.body, { subtree: true, attributes: true });

        return () => observer.disconnect();
    }, []);

    // console.log("calendar", workinCalendarHome);

    const badgeByStatus = useCallback((entry) => {
        if (!entry) return null;

        const { statusEn, holidayName, shiftNameEn } = entry;

        if (holidayName || statusEn === "Day Off") {
            return <Badge className={styles.customBadge} status="default" />;
        } else if (statusEn === "Absent") {
            return <Badge className={styles.customBadge} status="error" />;
        } else if (statusEn?.toLowerCase().includes("late")) {
            return <Badge className={styles.customBadge} status="warning" />;
        } else if (statusEn === "Normal") {
            return <Badge className={styles.customBadge} status="success" />;
        } else if (statusEn?.toLowerCase().includes("leave")) {
            return <Badge className={styles.customBadge} status="default" />;
        } else if (!statusEn && shiftNameEn) {
            return <Badge className={styles.customBadge} color="blue" />;
        } else {
            return null;
        }
    }, []);

    const dateCellRender = useCallback(
        (value, info) => {
            const calendarEntry = workinCalendarHome?.find(
                item => item.date === value.format("YYYY-MM-DD")
            );

            const isDayOff = calendarEntry?.statusEn == "Day Off";
            const isHoliday = calendarEntry?.holidayNameEn != null;
            const isNormal = calendarEntry?.statusEn === "Normal";
            const isLate = calendarEntry?.statusEn?.toLowerCase().includes("late");
            const isWeekend = value.format("ddd").match('(Sat|Sun)');
            const isOutOfMonth = value.month() !== viewDate.month() || value.year() !== viewDate.year(); // <-- แก้จาก currentDate เป็น viewDate
            const isFuture = value.isAfter(dayjs(), 'day');

            const getPopoverContent = () => {
                if (isDayOff) return <span>{i18n.language === "en" ? calendarEntry?.statusEn : calendarEntry?.status}</span>;
                if (calendarEntry?.statusEn?.toLowerCase().includes("leave")) return <span>{i18n.language === "en" ? calendarEntry?.statusEn : calendarEntry?.status}</span>;
                if (isHoliday) return <span>{i18n.language === "en" ? calendarEntry?.holidayNameEn : calendarEntry?.holidayName}</span>;
                if (!isDayOff && !isHoliday && calendarEntry) {
                    return (
                        <Flex vertical>
                            <Row justify="space-between" style={{ width: "100%", gap: "16px" }}>
                                <span style={{ color: "#1677ff", whiteSpace: "nowrap" }}>{t("shift.header")} </span>
                                <span style={{ color: "#1677ff", whiteSpace: "nowrap" }}>
                                    {i18n.language === "en"
                                        ? `${calendarEntry?.workInDateStart ? dayjs(calendarEntry?.workInDateStart, "HH:mm:ss").format("HH:mm") : "-"} - ${calendarEntry?.workInDateEnd ? dayjs(calendarEntry?.workInDateEnd, "HH:mm:ss").format("HH:mm") : "-"}`
                                        : `${calendarEntry?.workInDateStart ? dayjs(calendarEntry?.workInDateStart, "HH:mm:ss").format("HH:mm") : "-"} ถึง ${calendarEntry?.workInDateEnd ? dayjs(calendarEntry?.workInDateEnd, "HH:mm:ss").format("HH:mm") : "-"}`}
                                </span>
                            </Row>
                            {(isNormal || isLate) && (
                                <Row justify="space-between" style={{ width: "100%", gap: "16px" }}>
                                    <span style={{ color: isNormal ? "#52c41a" : isLate ? "#faad14" : "#000000", whiteSpace: "nowrap" }}>
                                        {i18n.language === "en" ? calendarEntry?.statusEn : calendarEntry?.status}
                                    </span>
                                    <span style={{ color: isNormal ? "#52c41a" : isLate ? "#faad14" : "#000000", whiteSpace: "nowrap" }}>
                                        {i18n.language === "en"
                                            ? `${calendarEntry?.checkInTime ? dayjs(calendarEntry?.checkInTime).format("HH:mm") : "-"} - ${calendarEntry?.checkOutTime ? dayjs(calendarEntry?.checkOutTime).format("HH:mm") : "-"}`
                                            : `${calendarEntry?.checkInTime ? dayjs(calendarEntry?.checkInTime).format("HH:mm") : "-"} ถึง ${calendarEntry?.checkOutTime ? dayjs(calendarEntry?.checkOutTime).format("HH:mm") : "-"}`}
                                    </span>
                                </Row>
                            )}
                            {calendarEntry?.statusEn === "Absent" && (
                                <span style={{ color: "#ff4d4f" }}>{t("home.absence")}</span>
                            )}
                        </Flex>
                    );
                }
            };

            const isSelected = selectedDetailDate?.isSame(value, 'day');
            const isToday = info.today.isSame(value, 'day');

            const statusMeta = calendarEntry ? getStatusColorMeta(calendarEntry) : null;
            const showDot = !!statusMeta && !isDayOff && !isHoliday && !isFuture;
            const dotColor = statusMeta?.dot;

            const isGreyedOut = isDayOff || isHoliday || isWeekend || isOutOfMonth;

            let cellBg = "transparent";
            let cellColor = isGreyedOut ? "#98A2B3" : "#1D2939";

            if (isSelected) {
                cellBg = "#1677ff";
                cellColor = "#fff";
            } else if (isToday) {
                cellBg = "#D6E9FF";
                cellColor = "#1677ff";
            }

            const handleClick = () => {
                setSelectedDetailDate(value);
            };

            const isCompact = !!selectedDetailDate;
            const cellSize = isCompact ? 15 : 18;
            const cellLineHeight = isCompact ? "14px" : "17px";
            const cellFontSize = isCompact ? 9 : 10;

            return (
                <Popover title={isToday ? t("units.today") : undefined} content={getPopoverContent()}>
                    <div onClick={handleClick} className={styles.dayCell}>
                        <div
                            className="ant-picker-cell-inner"
                            style={{
                                width: cellSize, height: cellSize, lineHeight: cellLineHeight, fontSize: cellFontSize,
                                borderRadius: "50%",
                                backgroundColor: cellBg,
                                color: cellColor,
                                fontWeight: "bold",
                            }}
                        >
                            {value.date()}
                        </div>
                        {showDot && (
                            <span
                                className={styles.dayDot}
                                style={{
                                    width: isCompact ? 3 : 4,
                                    height: isCompact ? 3 : 4,
                                    borderRadius: "50%",
                                    backgroundColor: dotColor,
                                    display: "inline-block",
                                }}
                            />
                        )}
                    </div>
                </Popover>
            );
        },
        [getCellStyle, i18n.language, selectedDetailDate, t, workinCalendarHome, viewDate],
    )

    useEffect(() => {
        if (currentCompany, currentEmployee && roles.length != 0) {
            if (roles.includes("ACCESS_EMPLOYEE|EMPLOYMENT|EMPLOYMENT_INFO") || roles.includes("ACCESS_HOME")) {
                getEmploymentInfoCallback()
            }
        }
    }, [currentCompany, currentEmployee, roles])


    const getEmploymentInfoCallback = useCallback(
        async () => {
            try {
                dispatch(setIsLoading(true));
                const response = await getEmploymentInformation({
                    requestId: generateRandomString(),
                    companyId: currentCompany,
                    employeeId: currentEmployee,
                    visible: false,
                    edit: false
                });
                dispatch(setCurrentEmploymentHome(response.data || {}));
            } catch (error) {
                // Alert({ type: "error", resultObject: error });
            } finally {
                dispatch(setIsLoading(false));
            }
        },
        [currentCompany, currentEmployee]
    );

    const getDataEmployeeWorkInCount = useCallback(
        async () => {
            try {
                dispatch(setIsLoading(true));
                const response = await getEmployeeWorkInCount({
                    companyId: currentCompany,
                    employeeId: currentEmployee
                });
                dispatch(setEmployeeWorkInCount(response.data?.content || {}));
            } catch (error) {
                // Alert({ type: "error", resultObject: error });
            } finally {
                dispatch(setIsLoading(false));
            }
        },
        [currentCompany, currentEmployee]
    );

    useEffect(() => {
        if (currentCompany && currentEmployee) {
            getDataEmployeeWorkInCount()
        }
    }, [currentCompany, currentEmployee])

    const getNoted = useCallback(
        (day) => {
            return (
                <Flex vertical >
                    <Flex justify='space-between'>
                        <span>Note</span>
                        <Button style={{
                            borderColor: "transparent",

                        }} onClick={() => {
                            setOpenNote({ ...openNote, open: false })
                        }}><CloseOutlined /></Button>
                    </Flex>
                    <Input.TextArea value={openNote?.[openNote?.currentDate?.format('YYYYMMMDD')]} onChange={(e) => {
                        console.log("e", e.target.value);
                        console.log("openNoteopenNoteopenNote", openNote, openNote?.currentDate?.format('YYYYMMMDD'));

                        setOpenNote({ ...openNote, [openNote?.currentDate?.format('YYYYMMMDD')]: e.target.value })
                    }} />
                </Flex>
            )
        }
        ,
        [currentDate, i18n.language, setOpenNote, openNote]
    )

    const getWorkInCalendar = useCallback(async (startDate, endDate) => {
        try {
            dispatch(setIsLoading(true))
            const yearFromStartDate = dayjs(startDate).year();
            setYear(yearFromStartDate);

            const response = await getWorkIn({
                employeeId: currentEmployee,
                companyId: currentCompany,
                year: yearFromStartDate,
                startDate: startDate,
                endDate: endDate,
            })
            dispatch(setWorkinCalendarHome(response?.data?.content))
        } catch (error) {
            Alert({ type: "error", resultObject: error });
        } finally {
            dispatch(setIsLoading(false))
        }
    }, [currentCompany, currentEmployee, dispatch])

    useEffect(() => {
        if (currentCompany && currentEmployee && (profile?.adminType !== "SUPER_ADMIN")
            && (profile?.isAdminEndpoint !== "Y")) {
            getWorkInCalendar(startDate, endDate)
        }
    }, [currentCompany, currentEmployee, endDate, getWorkInCalendar, profile, startDate])

    const cellRender = useCallback(
        (current, info) => {
            if (info.type === 'date') {
                return dateCellRender(current, info);
            } else {
                return info.originNode
            }
        },
        [dateCellRender],
    )

    const getCalendar = useCallback(
        () => {
            const customHeader = ({ value, onChange }) => {
                const handleMonthChange = (newValue) => {
                    onChange(newValue);
                    setViewDate(newValue); // <-- เพิ่มบรรทัดนี้ ให้ viewDate sync ตามหน้าที่กำลังดูจริง

                    const startDate = newValue.clone().startOf('month').format('YYYY-MM-DD');
                    const endDate = newValue.clone().endOf('month').format('YYYY-MM-DD');
                    getWorkInCalendar(startDate, endDate);
                };

                const prevMonth = () => {
                    const newValue = value.clone().subtract(1, 'month');
                    handleMonthChange(newValue);
                };

                const nextMonth = () => {
                    const newValue = value.clone().add(1, 'month');
                    handleMonthChange(newValue);
                };

                const thaiLocale = {
                    ...en, // ใช้โครงสร้างเดียวกับภาษาอังกฤษ
                    lang: {
                        ...en.lang,
                        locale: "th",
                        yearFormat: 'BBBB',
                        monthFormat: 'MMM',
                        cellYearFormat: 'BBBB',
                    },
                };

                const englishLocale = {
                    ...en,
                    lang: {
                        ...en.lang,
                        locale: "en",
                        yearFormat: 'YYYY',
                        monthFormat: 'MMM',
                        cellYearFormat: 'YYYY',
                    },
                };

                return (
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '4px 8px' }}>
                        <LeftOutlined style={{ fontSize: 12 }} onClick={prevMonth} />
                        <ConfigProvider theme={{ components: { DatePicker: { colorBorder: "transparent", hoverBorderColor: "transparent", activeBorderColor: "transparent", fontSize: 12 } } }}>
                            <DatePicker allowClear={false}
                                locale={i18n.language === "en" ? englishLocale : thaiLocale}
                                value={value} format={i18n.language === "en" ? "MMM YYYY" : "MMM BBBB"}
                                onChange={handleMonthChange}
                                picker="month"
                                style={{ cursor: "pointer" }} />
                        </ConfigProvider>
                        <RightOutlined style={{ fontSize: 12 }} onClick={nextMonth} />
                    </div>
                );
            }

            return (
                <ConfigProvider locale={i18n.language == 'en' ? enUS : thTH}>
                    <Calendar
                        headerRender={customHeader}
                        value={currentDate}
                        onSelect={setCurrentDate}
                        fullCellRender={cellRender}
                        fullscreen={false}
                    />
                    {openNote?.open && getNoted()}
                </ConfigProvider>
            )
        },
        [i18n.language, currentDate, cellRender, openNote?.open, getNoted]
    )

    // const dateCellRender = (value, info) => {
    //   if ((value.date()) == 8 || value.date() == 9 || value.date() == 11) {
    //     return (
    //       <div className="ant-picker-cell ant-picker-cell-in-view" style={{ background: "#AEFFEA" }}>
    //         <div class="ant-picker-cell-inner" > {value.date()}</div>
    //       </div>
    //     );
    //   } else {
    //     return (info.originNode)
    //   }
    // };

    const getInfo = useMemo(
        () => {
            let language = i18n.language == "en" ? "En" : "";
            return {
                employeeImage: currentEmploymentHome?.employeeImage,
                positionName: currentEmploymentHome?.position?.["name" + language] ?? "",
                employeeNo: currentEmploymentHome?.["employeeNo"],
                name: currentEmploymentHome?.["name" + language] ?? "",
                surName: currentEmploymentHome?.["surName" + language] ?? "",
                departmentName: currentEmploymentHome?.department?.["name" + language] ?? "",
                email: currentEmploymentHome?.["email"],
            }
        },
        [currentEmploymentHome, i18n.language],
    )

    // ---- ต้องอยู่ "หลัง" getInfo เพราะ dayRequestModal อ้างอิงถึง getInfo ----
    // ป้ายกะการทำงานของวันที่เลือก ใช้โชว์ใน SupervisorRequestOtModal (renderTitle)
    const selectedDayShiftLabel = useMemo(() => {
        if (!selectedDetailDate) return "";
        const entry = workinCalendarHome?.find(item => item.date === selectedDetailDate.format("YYYY-MM-DD"));
        return i18n.language === "en" ? entry?.shiftNameEn : entry?.shiftName;
    }, [workinCalendarHome, selectedDetailDate, i18n.language]);


    const dayRequestModal = useCallback(() => (
        <HomeDayRequestModal
            isOpen={isRequestModalOpen}
            onClose={() => setIsRequestModalOpen(false)}
            initialForm={initialRequestForm}
            selectedDate={selectedDetailDate?.format("YYYY-MM-DD")}
            selectedShift={selectedDayShiftLabel}
            employeeName={`${getInfo?.name ?? ""} ${getInfo?.surName ?? ""}`.trim()}
            workTypeOptions={workTypeOptions}
            leaveGroupOptions={leaveGroupOptions}
            onAttachFileChange={onAttachFileChange}
            setpreviousFilew={setpreviousFilew}
            handleOffSiteModalSubmit={onSubmitOffSiteWork}
            handleLeaveModalSubmit={onSubmitLeave}
            handleOtModalSubmit={onSubmitSupRequest}
        />
    ), [
        isRequestModalOpen,
        initialRequestForm,
        selectedDetailDate,
        selectedDayShiftLabel,
        getInfo,
        workTypeOptions,
        leaveGroupOptions,
        onAttachFileChange,
        setpreviousFilew,
        onSubmitOffSiteWork,
        onSubmitLeave,
        onSubmitSupRequest,
    ]);

    function createImageUrl(base64Data, contentType) {
        return `data:${contentType};base64,${base64Data}`;
    }

    function arrayBufferToBase64(buffer) {
        let binary = '';
        const bytes = new Uint8Array(buffer);
        const len = bytes.byteLength;
        for (let i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
    }
    const userAvatar = useCallback(
        () => {
            if (getInfo.employeeImage) {
                const imageUrl = createImageUrl(getInfo.employeeImage, "image/png");
                return imageUrl;
            } else {
                return null
            }
        },
        [getInfo.employeeImage],
    )

    const calendarWeekCount = useMemo(() => {
        const startOfMonth = viewDate.startOf('month');
        const endOfMonth = viewDate.endOf('month');
        const startWeekday = startOfMonth.day();
        const totalDays = endOfMonth.date();
        return Math.ceil((startWeekday + totalDays) / 7);
    }, [viewDate]);
    const needsSixthRow = useMemo(() => {
        const startOfMonth = viewDate.startOf('month');
        const startWeekday = startOfMonth.day();
        const totalDays = viewDate.endOf('month').date();
        return (startWeekday + totalDays) > 35;
    }, [viewDate]);
    const dynamicCalendarScale = calendarWeekCount === 6
        ? CALENDAR_SCALE
        : CALENDAR_SCALE;
    const getCardInfo = useCallback(
        () => {
            return (
                <Flex align="center" style={{ height: "100%", width: "100%" }}>
                    <Row justify={"center"} align="middle" wrap={false} style={{ gap: "12px", width: "100%" }}>
                        <Col flex="0 0 auto">
                            <Avatar
                                size={80}
                                alt="logo"
                                src={userAvatar()}
                                icon={!userAvatar() && <UserOutlined />}
                            />
                        </Col>
                        <Col flex="0 1 auto" style={{ minWidth: 0, maxWidth: "100%" }}>
                            <h1 style={{ margin: 0 }}>{(getInfo?.name ?? "") + " " + (getInfo?.surName ?? "")}</h1>
                            <Flex vertical gap={4} style={{ marginTop: 4 }}>
                                <Flex wrap={false} style={{ lineHeight: 1.5 }}>
                                    <span style={{ color: "#667085", flexShrink: 0, whiteSpace: "nowrap" }}>
                                        {t('home.position')} :&nbsp;
                                    </span>
                                    <span style={{ minWidth: 0 }}>{getInfo.positionName}</span>
                                </Flex>
                                <Flex wrap={false} style={{ lineHeight: 1.5 }}>
                                    <span style={{ color: "#667085", flexShrink: 0, whiteSpace: "nowrap" }}>
                                        {t('home.department')} :&nbsp;
                                    </span>
                                    <span style={{ minWidth: 0 }}>{getInfo.departmentName ?? ""}</span>
                                </Flex>
                            </Flex>
                        </Col>
                    </Row>
                </Flex>
            )
        },
        [getInfo, isTabletOrMobile],
    )
    // const contentStyle = {
    //     margin: 0,
    //     height: '160px',
    //     color: '#fff',
    //     lineHeight: '160px',
    //     textAlign: 'center',
    //     background: '#364d79',
    // };
    const getAnnouncement = useCallback(
        () => {
            if (!dataSource || dataSource.length === 0) {
                return (
                    <Flex align="center" justify="center" style={{ height: "100%" }}>
                        <Empty
                            description={t("news.no-data")}
                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                            imageStyle={{ height: 40 }}
                        />
                    </Flex>
                );
            }

            return (
                <Flex vertical style={{ height: "100%" }}>
                    <Carousel autoplay fade dotPosition="right" className={styles.customCarousel} style={{ flex: 1 }}>
                        {dataSource?.slice(0, 5)?.map((item, index) => (
                            <div key={index}>
                                <Flex
                                    key={item.title}
                                    style={{ overflowWrap: "break-word", gap: "12px", padding: "8px" }}
                                >
                                    <Col span={7}>
                                        <img style={{ minWidth: "100%", maxWidth: "100%", borderRadius: "16px" }} alt="logo" src={item.avatar}></img>
                                    </Col>
                                    <Col span={17}>
                                        <Flex vertical style={{ rowGap: "2vh" }}>
                                            <Flex vertical style={{ rowGap: "1vh", justifyContent: "start" }}>
                                                <Row>
                                                    <h3 style={{ color: "#2BA4DD" }}>{item.title}</h3>
                                                </Row>
                                                <Row>
                                                    <Paragraph
                                                        ellipsis={{
                                                            rows: 2,
                                                            expandable: false,
                                                            symbol: 'more',
                                                        }}
                                                    >
                                                        <div dangerouslySetInnerHTML={{ __html: item.description }} />
                                                    </Paragraph>
                                                </Row>
                                            </Flex>

                                            <Row>
                                                <Col span={12} style={{ color: "#9D9D9D" }}>
                                                    <Row style={{ gap: "8px", alignContent: "center" }}>
                                                        <CalendarOutlined />
                                                        <span>{dayjs(item?.startAnnounce).format(i18n.language === "en" ? "DD MMMM YYYY" : "DD MMMM BBBB")}</span>
                                                    </Row>
                                                    <Row style={{ gap: "8px", alignContent: "center" }}>
                                                        <UserOutlined />
                                                        <span>{item.announcementBy}</span>
                                                    </Row>
                                                </Col>
                                                <Col span={11} style={{ alignContent: "end", textAlign: "right" }}>
                                                    <Button
                                                        type="text"
                                                        onClick={() => {
                                                            navigate("/news_list/view", { state: item })
                                                        }}
                                                        style={{ width: "120px", borderRadius: "20rem" }}
                                                    >
                                                        <span style={{ color: "#2BA4DD" }}>{t("btn.read_more")}</span>
                                                        <ArrowRightOutlined style={{ color: "#2BA4DD" }} />
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </Flex>
                                    </Col>
                                </Flex>
                            </div>
                        ))}
                    </Carousel>
                    <Row justify={"center"} style={{ padding: "10px 0" }}>
                        <Button size="small" type="text" onClick={() => {
                            navigate("/news_list")
                        }}>
                            <span style={{ color: "#009DE6" }}>{t('home.btn.view-all')}</span>
                        </Button>
                    </Row>
                </Flex>
            )
        },
        [dataSource, pagination, total, t],
    )
    const getAnnouncementGrid = useCallback(() => {
        return (
            <Row gutter={16}>
                {dataSource?.slice(0, 3)?.map((item, index) => (
                    <Col span={8} key={index}>
                        <Card
                            hoverable
                            onClick={() => navigate("/news_list/view", { state: item })}
                            cover={<img alt="news" src={item.avatar} style={{ height: 140, objectFit: "cover", borderRadius: "8px 8px 0 0" }} />}
                            styles={{ body: { padding: 12 } }}
                        >
                            <Flex vertical gap={6}>
                                <span style={{ color: "#2BA4DD", fontWeight: 600 }}>{item.title}</span>
                                <span style={{ color: "#9D9D9D", fontSize: 12 }}>
                                    {dayjs(item?.startAnnounce).format(i18n.language === "en" ? "DD MMMM YYYY" : "DD MMMM BBBB")}
                                </span>
                            </Flex>
                        </Card>
                    </Col>
                ))}
            </Row>
        );
    }, [dataSource, i18n.language, navigate]);
    const getTxnTime = useCallback(
        () => {
            return (<>
                <Space style={{
                    justifyContent: !isOver ? "left" : "center",
                    rowGap: "24px",
                    width: "100%"
                }}
                    size={isOver ? 16 : null}
                    direction={isOver ? 'horizontal' : 'vertical'}
                >
                    <Flex style={{ width: "100%", gap: isOver ? "16px" : null }}>
                        <Col span={isOver ? null : 12}>
                            <Flex gap={4}>
                                <Image preview={false} src={Early} />
                                <Flex vertical>
                                    <span style={{ fontWeight: "bold", fontSize: i18n.language == "en" ? "11px" : "14px", color: "#667085" }}>{t("home.eary_come")}</span>
                                    <span style={{ color: "#667085" }} >{employeeWorkInCount?.checkInEarly ?? 0}</span>
                                </Flex>
                            </Flex>
                        </Col>
                        <Col span={isOver ? null : 12}>
                            <Flex gap={4}>
                                <Image preview={false} src={Late} />
                                <Flex vertical>
                                    <span style={{ fontWeight: "bold", fontSize: i18n.language == "en" ? "11px" : "14px", color: "#667085" }}>{t("home.late")}</span>
                                    <span style={{ color: "#667085" }} >{employeeWorkInCount?.checkInLate ?? 0}</span>
                                </Flex>
                            </Flex>
                        </Col>
                    </Flex>
                    <Flex style={{ width: "100%", gap: isOver ? "16px" : null }}>
                        <Col span={isOver ? null : 12}>
                            <Flex gap={4}>
                                <Image preview={false} src={Late} />
                                <Flex vertical>
                                    <span style={{ fontWeight: "bold", fontSize: i18n.language == "en" ? "11px" : "14px", color: "#667085" }}>{t("home.early")}</span>
                                    <span style={{ color: "#667085" }} >{employeeWorkInCount?.checkOutEarly ?? 0}</span>
                                </Flex>
                            </Flex>
                        </Col>
                        <Col span={isOver ? null : 12}>
                            <Flex gap={4}>
                                <Image preview={false} src={Early} />
                                <Flex vertical>
                                    <span style={{ fontWeight: "bold", fontSize: i18n.language == "en" ? "11px" : "14px", color: "#667085" }}>{t("home.back_late")}</span>
                                    <span style={{ color: "#667085" }} >{employeeWorkInCount?.checkOutLate ?? 0}</span>
                                </Flex>
                            </Flex>
                        </Col>
                    </Flex>
                </Space>
            </>
            )
        },
        [i18n, isOver],
    )

    const showModal = (policy) => {
        setSelectedPolicy(policy);
        setIsModalOpen(true);
    };

    const handleOk = () => {
        setIsModalOpen(false);
        setSelectedPolicy(null);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
        setSelectedPolicy(null);
    };

    const getPolicyCategory = useCallback(async (values) => {
        console.count("getPolicyCategory");

        try {
            dispatch(setIsLoading(true));

            const response = await services.getPolicyCategory({
                ...values,
                requestId: generateRandomString(),
                companyId: currentCompany,
                page: 0,
                size: 50,
            });

            const category = response?.data?.content[0]?.policyCategory || [];

            console.log("Categories:", category.length);

            await Promise.all(
                category.map((item) =>
                    services.getPolicyByCategoryHome({
                        ...values,
                        requestId: generateRandomString(),
                        companyId: currentCompany,
                        policyCategoryId: item.policyCategoryId,
                    })
                )
            );
        } finally {
            dispatch(setIsLoading(false));
        }
    }, [currentCompany, dispatch]);

    useEffect(() => {
        console.log("useEffect getPolicyCategory", {
            currentCompany,
            time: new Date().toISOString(),
        });

        if (currentCompany) {
            getPolicyCategory();
        }
    }, [currentCompany, getPolicyCategory]);

    const policyList = useMemo(
        () => {
            if (policyCategory) {
                const data = policyCategory?.filter(category => category.announcementStatus !== "N")?.map((data, i) => {
                    return (
                        {
                            key: data?.policyCategoryId,
                            label: data?.policyCategoryName,
                            children:
                                (
                                    <>
                                        <Tree
                                            showIcon
                                            treeData={data?.policyList?.map((policy) => ({
                                                title: policy?.policyName,
                                                key: policy?.id,
                                                icon: <NotificationOutlined />,
                                                description: policy?.description,
                                                lastedModified: policy?.lastModified?.name
                                                    ? i18n.language === "en"
                                                        ? `${policy.lastModified.nameEn || ""} ${policy.lastModified.surNameEn || ""}`.trim()
                                                        : `${policy.lastModified.name || ""} ${policy.lastModified.surName || ""}`.trim()
                                                    : "-"
                                            }))}
                                            onSelect={(selectedKeys, { node }) => showModal(node)}
                                        />
                                        <Modal
                                            title={<Flex vertical>
                                                <h3>{selectedPolicy?.title}</h3>
                                                <h5 style={{ color: "#9D9D9D", fontWeight: "lighter" }}>{t("policy.label.last_modified")} {selectedPolicy?.lastedModified}</h5>
                                            </Flex>}
                                            open={isModalOpen}
                                            onOk={handleOk}
                                            onCancel={handleCancel}
                                            footer={false}
                                            width={"50vw"}
                                        >
                                            <Flex>
                                                <span dangerouslySetInnerHTML={{ __html: selectedPolicy?.description }} />
                                            </Flex>
                                        </Modal>
                                    </>
                                )
                        }
                    )
                }); return data;
            } else {
                return []
            }
        }, [isModalOpen, policyCategory, selectedPolicy]
    )

    const NEWS_POLICY_TAG_META = {
        news: { bg: "#EAF3FF", fg: "#1C64F2" },
        policy: { bg: "#F4EBFF", fg: "#8357DF" },
    };

    const stripHtml = (html) => (html ?? "").replace(/<[^>]*>/g, "");

    // flat policy items (separate from the Tree-grouped `policyList` used elsewhere)
    const policyFlatList = useMemo(() => {
        if (!policyCategory) return [];
        return policyCategory
            .filter((category) => category.announcementStatus !== "N")
            .flatMap((category) =>
                (category?.policyList ?? []).map((policy) => ({
                    id: `policy-${policy?.id}`,
                    type: "policy",
                    title: policy?.policyName,
                    description: policy?.description,
                    date: policy?.startDate ?? policy?.effectiveDate ?? policy?.createdDate ?? null, // TODO(backend): confirm date field for policy items
                    image: policy?.cover ? createImageUrl(policy.cover, "image/png") : null, // TODO(backend): confirm cover field exists for policy items
                    onClick: () =>
                        showModal({
                            title: policy?.policyName,
                            description: policy?.description,
                            lastedModified: policy?.lastModified?.name
                                ? i18n.language === "en"
                                    ? `${policy.lastModified.nameEn || ""} ${policy.lastModified.surNameEn || ""}`.trim()
                                    : `${policy.lastModified.name || ""} ${policy.lastModified.surName || ""}`.trim()
                                : "-",
                        }),
                }))
            );
    }, [policyCategory, i18n.language]);

    const newsFlatList = useMemo(() => {
        return (dataSource ?? []).map((item, i) => ({
            id: `news-${i}`,
            type: "news",
            title: item.title,
            description: item.description,
            date: item.startAnnounce,
            image: item.avatar,
            onClick: () => navigate("/news_list/view", { state: item }),
        }));
    }, [dataSource, navigate]);

    const newsAndPolicyList = useMemo(() => {
        return [...newsFlatList, ...policyFlatList]
            .sort((a, b) => dayjs(b.date).valueOf() - dayjs(a.date).valueOf())
            .slice(0, 5);
    }, [newsFlatList, policyFlatList]);

    const getNewsAndPolicyList = useCallback(() => {
        if (!newsAndPolicyList.length) {
            return (
                <Flex align="center" justify="center" style={{ height: "100%" }}>
                    <Empty description={t("news.no-data")} image={Empty.PRESENTED_IMAGE_SIMPLE} imageStyle={{ height: 40 }} />
                </Flex>
            );
        }

        return (
            <List
                className={styles.compactList}
                dataSource={newsAndPolicyList}
                renderItem={(item) => {
                    const meta = NEWS_POLICY_TAG_META[item.type];
                    return (
                        <List.Item style={{ cursor: "pointer", padding: "10px 0" }} onClick={item.onClick}>
                            <Flex gap={12} align="flex-start" style={{ width: "100%" }}>
                                <div style={{ position: "relative", flexShrink: 0 }}>
                                    {item.image ? (
                                        <img
                                            src={item.image}
                                            alt={item.title}
                                            style={{ width: 64, height: 64, borderRadius: 12, objectFit: "cover" }}
                                        />
                                    ) : (
                                        <div style={{ width: 64, height: 64, borderRadius: 12, backgroundColor: "#F2F4F7" }} />
                                    )}
                                    <span
                                        style={{
                                            position: "absolute",
                                            top: -8,
                                            left: -8,
                                            fontSize: 10,
                                            fontWeight: 600,
                                            padding: "2px 8px",
                                            borderRadius: 999,
                                            backgroundColor: meta.bg,
                                            color: meta.fg,
                                            boxShadow: "0 0 0 2px #fff",
                                            whiteSpace: "nowrap",
                                        }}
                                    >
                                        {item.type === "news" ? t("news.header") : t("policy.header")}
                                    </span>
                                </div>
                                <Flex vertical gap={2} style={{ minWidth: 0, flex: 1 }}>
                                    <span style={{ fontWeight: 600, fontSize: 13, color: "#1D2939" }}>{item.title}</span>
                                    <Paragraph ellipsis={{ rows: 1 }} style={{ fontSize: 12, color: "#667085", margin: 0 }}>
                                        {stripHtml(item.description)}
                                    </Paragraph>
                                    <span style={{ fontSize: 11, color: "#98A2B3" }}>
                                        {item.date
                                            ? dayjs(item.date).format(i18n.language === "en" ? "DD MMM YYYY" : "DD MMM BBBB")
                                            : "-"}
                                    </span>
                                </Flex>
                            </Flex>
                        </List.Item>
                    );
                }}
            />
        );
    }, [newsAndPolicyList, t, i18n.language]);
    const getPolicyAnnouncement = useCallback(
        () => {
            if (policyList && policyList.length > 0) {
                return (
                    <>
                        {policyList.map((category, index) => (
                            <Collapse key={index} items={[category]} style={{ marginBottom: "16px" }} />
                        ))}
                        <Row justify={"center"} style={{
                            position: "absolute",
                            bottom: "0",
                            left: "0",
                            width: "100%",
                            padding: "10px 0",
                            backgroundColor: "white",
                            borderRadius: "0px 0px 16px 16px"
                        }}>
                            <Button size="small" type="text" onClick={() => {
                                navigate("/news_policy/policy");
                            }}>
                                <span style={{ color: "#009DE6" }}>{t('home.btn.view-all')}</span>
                            </Button>
                        </Row>
                    </>
                );
            }
            return null;
        }, [policyList]
    )
    const todayWork = useMemo(() => {
        const todayStr = dayjs().format("YYYY-MM-DD");
        const entry = workinCalendarHome?.find(item => item.date === todayStr);

        if (!entry) {
            return { checkIn: null, checkOut: null, shiftStart: null, shiftEnd: null, workedMinutes: 0, shiftMinutes: 0, percent: 0 };
        }

        const workStart = entry.workInDateStart ? dayjs(entry.workInDateStart, "HH:mm:ss") : null;
        const workEnd = entry.workInDateEnd ? dayjs(entry.workInDateEnd, "HH:mm:ss") : null;
        const breakStart = entry.breakTimeStart ? dayjs(entry.breakTimeStart, "HH:mm:ss") : null;
        const breakEnd = entry.breakTimeEnd ? dayjs(entry.breakTimeEnd, "HH:mm:ss") : null;

        const shiftMinutes = (workStart && workEnd)
            ? workEnd.diff(workStart, "minute") - (breakStart && breakEnd ? breakEnd.diff(breakStart, "minute") : 0)
            : 0;

        let percent = 0;
        if (workStart && workEnd) {
            const now = dayjs();
            const nowTimeOnly = dayjs().hour(now.hour()).minute(now.minute()).second(0);
            const shiftStartToday = dayjs().hour(workStart.hour()).minute(workStart.minute()).second(0);
            const shiftEndToday = dayjs().hour(workEnd.hour()).minute(workEnd.minute()).second(0);
            const totalShiftSpan = shiftEndToday.diff(shiftStartToday, "minute");
            const elapsed = nowTimeOnly.diff(shiftStartToday, "minute");
            percent = totalShiftSpan > 0 ? Math.min(100, Math.max(0, Math.round((elapsed / totalShiftSpan) * 100))) : 0;
        }

        return {
            checkIn: entry.checkInTime ? dayjs(entry.checkInTime).format("HH:mm") : null,
            checkOut: entry.checkOutTime ? dayjs(entry.checkOutTime).format("HH:mm") : null,
            shiftStart: workStart ? workStart.format("HH:mm") : null,
            shiftEnd: workEnd ? workEnd.format("HH:mm") : null,
            workedMinutes: entry.workTime ?? 0,
            shiftMinutes,
            percent,
        };
    }, [workinCalendarHome]);

    const getGreeting = useCallback(() => (
        <Flex vertical style={{ lineHeight: 1.2 }}>
            <span style={{ fontWeight: 700, fontSize: 18, color: "#1D2939" }}>
                {t('home.greeting', { name: `${getInfo?.name ?? ""} ${getInfo?.surName ?? ""}`.trim() })}
            </span>
            <span style={{ color: "#667085", fontSize: 12 }}>
                {dayjs().format(i18n.language === "en" ? "dddd D MMMM YYYY" : "dddd D MMMM BBBB")}
            </span>
        </Flex>
    ), [getInfo, i18n.language, t]);

    const getTodayWorkSummary = useCallback(() => {
        return (
            <Flex vertical style={{ width: "100%" }} gap={4}>
                <Row justify="space-between">
                    <Col style={{ textAlign: "center" }}>
                        <div style={{ color: "#667085", fontSize: 12 }}>{t("home.check-in")}</div>
                        <div style={{ color: "#12B76A", fontWeight: "bold" }}>
                            {todayWork.checkIn ?? "-"} {todayWork.checkIn && <CheckCircleFilled style={{ color: "#12B76A", fontSize: 12 }} />}
                        </div>
                    </Col>
                    <Col style={{ textAlign: "center" }}>
                        <div style={{ color: "#667085", fontSize: 12 }}>{t("home.current-time")}</div>
                        <div style={{ color: "var(--button-color)", fontWeight: "bold" }}>
                            {nowClock.format("HH:mm")} <ClockCircleFilled style={{ color: "var(--button-color)", fontSize: 12 }} />
                        </div>
                    </Col>
                    <Col style={{ textAlign: "center" }}>
                        <div style={{ color: "#667085", fontSize: 12 }}>{t("home.check-out")}</div>
                        <div style={{ fontWeight: "bold" }}>{todayWork.checkOut ?? "-"}</div>
                    </Col>
                </Row>
                <Progress percent={todayWork.percent} showInfo={false} strokeColor="var(--button-color)" />
                <span style={{ textAlign: "center", color: "#667085", fontSize: 12 }}>
                    {t("home.worked-already", {
                        hour: Math.floor(todayWork.workedMinutes / 60),
                        min: todayWork.workedMinutes % 60
                    })}
                </span>
            </Flex>
        );
    }, [todayWork, t, nowClock]);
    const getShiftSummary = useCallback(() => {
        return (
            <Flex vertical gap={16} style={{ width: "100%" }}>
                <span style={{ fontWeight: "bold" }}>{t("home.shift.title")}</span>

                <Flex vertical gap={0}>
                    <span style={{ color: "#667085", fontSize: 12 }}>{t("home.check-in")}</span>
                    <span style={{ fontWeight: "bold", color: "var(--button-color)" }}>{todayWork.shiftStart ?? "-"}</span>
                </Flex>

                <Flex vertical gap={0}>
                    <span style={{ color: "#667085", fontSize: 12 }}>{t("home.check-out")}</span>
                    <span style={{ fontWeight: "bold", color: "var(--button-color)" }}>{todayWork.shiftEnd ?? "-"}</span>
                </Flex>
            </Flex>
        );
    }, [todayWork, t]);
    const getQuickActions = useCallback(() => {
        const actions = [
            { key: "myDocument", icon: <ContainerFilled />, label: t("home.action.my.document"), path: "/my_document/my_request", state: { initialMenu: "DOCUMENT_REQUEST" }, bg: "#EDE9FE", fg: "#7C3AED" },
            { key: "leave", icon: <CalendarOutlined />, label: t("home.action.leave"), path: "/my_document/my_request", state: { initialMenu: "LEAVE" }, bg: "#ffdddb", fg: "#FF4136" },
            { key: "ot", icon: <ClockCircleOutlined />, label: t("home.action.ot"), path: "/my_document/my_request", state: { initialMenu: "OVERTIME" }, bg: "#D1FAE5", fg: "#12B76A" },
            { key: "editTime", icon: <EditOutlined />, label: t("home.action.edit-time"), path: "/my_document/my_request", state: { initialMenu: "ENDORSE_TIME" }, bg: "#FEF3C7", fg: "#F79009" },
        ];
        return (
            <Row gutter={[8, 12]} style={{ width: "100%" }}>
                {actions.map(a => (
                    <Col span={6} key={a.key}>
                        <Flex
                            vertical
                            align="center"
                            justify="flex-start"
                            gap={8}
                            onClick={() => navigate(a.path, { state: a.state })}
                            style={{ cursor: "pointer" }}
                        >
                            <Flex
                                align="center"
                                justify="center"
                                style={{
                                    width: 52,
                                    height: 52,
                                    borderRadius: "50%",
                                    backgroundColor: a.bg,
                                    transition: "opacity 0.15s ease",
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.opacity = 0.8}
                                onMouseLeave={(e) => e.currentTarget.style.opacity = 1}
                            >
                                <span style={{ fontSize: 22, color: a.fg }}>
                                    {a.icon}
                                </span>
                            </Flex>
                            <span style={{ fontSize: 12, fontWeight: 700, textAlign: "center", color: "#1D2939", lineHeight: 1.2 }}>
                                {a.label}
                            </span>
                        </Flex>
                    </Col>
                ))}
            </Row>
        );
    }, [navigate, t]);

    const { teamWorkingCount, teamWorkingDetail } = useSelector((state) => state.employee);
    const [teamModalOpen, setTeamModalOpen] = useState(false);
    const computedLeaveToday = useMemo(
        () => (teamWorkingDetail || []).filter(o => o.isLeaveToday === "Y").length,
        [teamWorkingDetail]
    );
    const getTeamWorkingCount = useCallback(async () => {
        try {
            const res = await getEmployeeWorkingCountReport({
                requestId: generateRandomString(),
                companyId: currentCompany,
                employeeId: currentEmployee,
                selecttype: "today",
                lang: i18n.language,
            });
            dispatch(setTeamWorkingCount(res?.data || {}));
        } catch (error) {
            // silent fail, keep default zeros in UI
        }
    }, [currentCompany, currentEmployee, dispatch, i18n.language]);

    const getTeamWorkingDetail = useCallback(async () => {
        try {
            const res = await getEmployeeWorkingDetailReport({
                requestId: generateRandomString(),
                companyId: currentCompany,
                employeeId: currentEmployee,
                type: "all",
                page: 0,
                size: 100,
                lang: i18n.language,
            });
            dispatch(setTeamWorkingDetail(res?.data?.timeAttendanceDetailEnt || []));
        } catch (error) {
            // silent fail, keep empty list in UI
        }
    }, [currentCompany, currentEmployee, dispatch, i18n.language]);



    const getEmployeeTodayStatuses = useCallback((entry) => {
        if (entry?.statusTodayEn) return [entry.statusTodayEn];
        if (entry?.isLeaveToday === "Y") return ["OnLeave"];

        const isDayOff = entry?.isWorkingDayToday === "N";

        const todayCheckIn = (entry?.checkIn || []).find(
            (c) => c.checkInDatetime && dayjs(c.checkInDatetime).isSame(dayjs(), "day")
        );

        if (todayCheckIn) {
            let presentStatus = "Present";
            if (entry?.shiftStartToday) {
                const shiftStart = dayjs(entry.shiftStartToday, "HH:mm:ss");
                const checkInTime = dayjs(todayCheckIn.checkInDatetime);
                const shiftStartToday = dayjs()
                    .hour(shiftStart.hour())
                    .minute(shiftStart.minute())
                    .second(0);
                presentStatus = checkInTime.isAfter(shiftStartToday) ? "Late" : "Present";
            }
            return isDayOff ? ["DayOff", presentStatus] : [presentStatus];
        }

        const notClockedStatus = dayjs().hour() < 17 ? "NotClockedIn" : "Absent";
        return isDayOff ? ["DayOff", notClockedStatus] : [notClockedStatus];
    }, []);

    const teamStatusMeta = {
        Present: { tag: t("home.team.tag.present"), color: "#12B76A" },
        Late: { tag: t("home.team.tag.late"), color: "orange" },
        OnLeave: { tag: t("home.team.tag.on-leave"), color: "purple" },
        Absent: { tag: t("home.team.tag.absent"), color: "red" },
        NotClockedIn: { tag: t("home.team.tag.not-clocked-in"), color: "default" },
        DayOff: { tag: t("home.team.tag.day-off"), color: "#585757" },
    };

    const teamFollowUpList = useMemo(() => {

        return (teamWorkingDetail || [])
            .map((o) => ({
                id: o.empId,
                name: `${o["empFirstName" + (i18n.language == "en" ? "En" : "")] ?? ""} ${o["empLastName" + (i18n.language == "en" ? "En" : "")] ?? ""}`.trim(),
                position: o.companyPositionHierarchy?.["positionName" + (i18n.language == "en" ? "En" : "Th")] ?? "",
                avatar: o.employeeImage ? `data:image/jpeg;base64,${o.employeeImage}` : null,
                statuses: getEmployeeTodayStatuses(o),
                leaveTypeToday: i18n.language === "en" ? o?.leaveTypeNameEnToday : o?.leaveTypeNameToday,
                checkInTime: o.checkIn?.[0]?.checkInDatetime ? dayjs(o.checkIn[0].checkInDatetime).format("HH:mm") : null,
                raw: o,
            }))
            .filter((o) => !o.statuses.includes("Present"));
    }, [teamWorkingDetail, i18n.language, getEmployeeTodayStatuses]);

    const teamAllList = useMemo(() => {
        let language = i18n.language == "en" ? "En" : "Th";
        return (teamWorkingDetail || [])
            .map((o) => ({
                id: o.empId,
                name: `${o["empFirstName" + (i18n.language == "en" ? "En" : "")] ?? ""} ${o["empLastName" + (i18n.language == "en" ? "En" : "")] ?? ""}`.trim(),
                position: o.companyPositionHierarchy?.["positionName" + language] ?? "",
                avatar: o.employeeImage ? `data:image/jpeg;base64,${o.employeeImage}` : null,
                statuses: getEmployeeTodayStatuses(o),
                leaveTypeToday: i18n.language === "en" ? o?.leaveTypeNameEnToday : o?.leaveTypeNameToday,
                checkInTime: o.checkIn?.[0]?.checkInDatetime ? dayjs(o.checkIn[0].checkInDatetime).format("HH:mm") : null,
                checkInDatetime: o.checkIn?.[0]?.checkInDatetime ?? null,
                raw: o,
            }));
    }, [teamWorkingDetail, i18n.language, getEmployeeTodayStatuses]);

    const teamRecentList = useMemo(() => {
        return [...teamAllList].sort((a, b) => {
            const at = a.checkInDatetime ? dayjs(a.checkInDatetime).valueOf() : 0;
            const bt = b.checkInDatetime ? dayjs(b.checkInDatetime).valueOf() : 0;
            return bt - at;
        });
    }, [teamAllList]);


    const getTeamTotal = useCallback(() => teamWorkingCount?.numberOfSubOrdinates ?? 0, [teamWorkingCount]);

    const [statusModal, setStatusModal] = useState({ open: false, key: null, label: "" });

    const statusModalList = useMemo(() => {
        if (!statusModal.key) return [];
        return teamAllList.filter((o) => o.statuses.includes(statusModal.key));
    }, [teamAllList, statusModal.key]);

    const teamStatusModal = useCallback(() => (
        <Modal
            title={statusModal.label}
            open={statusModal.open}
            onCancel={() => setStatusModal({ open: false, key: null, label: "" })}
            footer={false}
            width={480}
        >
            <div style={{ maxHeight: "60vh", overflow: "auto", scrollbarWidth: "thin" }}>
                <List dataSource={statusModalList} renderItem={renderFollowUpItem} />
            </div>
        </Modal>
    ), [statusModal, statusModalList]);
    const teamStatItem = (item) => (
        <Col flex="1" key={item.key}>
            <Flex
                vertical
                align="flex-start"
                justify="center"
                gap={2}
                onClick={() => setStatusModal({ open: true, key: item.statusValue, label: item.label })}
                style={{
                    backgroundColor: item.color,
                    borderRadius: 12,
                    padding: "10px 12px",
                    minHeight: 56,
                    cursor: "pointer",
                }}
            >
                <span style={{ fontWeight: 700, fontSize: 18, color: "#fff", lineHeight: 1.2 }}>{item.value}</span>
                <span style={{ fontWeight: 700, fontSize: 11, color: "#fff", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "100%" }}>
                    {item.label}
                </span>
            </Flex>
        </Col>
    );

    const renderFollowUpItem = (item) => (
        <List.Item style={{ padding: "6px 0" }}>
            <Flex justify="space-between" align="center" style={{ width: "100%" }}>
                <Flex align="center" gap={8}>
                    <Avatar size={30} src={item.avatar} icon={!item.avatar && <UserOutlined />} />
                    <Flex vertical gap={0}>
                        <span style={{ fontWeight: 600, fontSize: 12.5 }}>{item.name}</span>
                        <span style={{ fontSize: 11, color: "#667085" }}>{item.position || "-"}</span>
                    </Flex>
                </Flex>
                <Flex vertical align="end" gap={4} style={{ maxWidth: 220 }}>
                    <Flex gap={6} align="center" justify="end" wrap="wrap">
                        {item.statuses.map((status) => {
                            const meta = teamStatusMeta[status];
                            const borderColor = meta?.color === "default" ? "#D0D5DD" : meta?.color;
                            const textColor = meta?.color === "default" ? "#667085" : meta?.color;
                            return (
                                <span
                                    key={status}
                                    style={{
                                        fontSize: 10.5,
                                        lineHeight: "18px",
                                        padding: "0 10px",
                                        borderRadius: 999,
                                        border: `1px solid ${borderColor}`,
                                        color: textColor,
                                        backgroundColor: "#fff",
                                        whiteSpace: "nowrap",
                                    }}
                                >
                                    {status === "OnLeave" ? (item.leaveTypeToday ?? meta.tag) : meta?.tag}
                                </span>
                            );
                        })}
                    </Flex>
                    {item.checkInTime && (
                        <span style={{ fontSize: 11, color: "#98A2B3", whiteSpace: "nowrap" }}>
                            {t('home.team.checkin-time', { time: item.checkInTime })}
                        </span>
                    )}
                </Flex>
            </Flex>
        </List.Item>
    );

    const teamAllModal = useCallback(() => (
        <Modal
            title={t("home.team.title")}
            open={teamModalOpen}
            onCancel={() => setTeamModalOpen(false)}
            footer={false}
            width={480}
        >
            <div style={{ maxHeight: "60vh", overflow: "auto", scrollbarWidth: "thin" }}>
                <List dataSource={teamRecentList} renderItem={renderFollowUpItem} />
            </div>
        </Modal>
    ), [teamModalOpen, teamRecentList, t, navigate]);

    const getTeamToday = useCallback(() => {
        const presentCount = teamAllList.filter(o => o.statuses.includes("Present")).length;

        const stats = [
            { key: "present", statusValue: "Present", label: t("home.team.present"), value: presentCount, color: "#12B76A", bg: "#ECFDF3", icon: <CheckCircleFilled /> },
            { key: "onLeave", statusValue: "OnLeave", label: t("home.team.on-leave"), value: computedLeaveToday ?? 0, color: "#8357DF", bg: "#F4EBFF", icon: <TeamOutlined /> },
            { key: "late", statusValue: "Late", label: t("home.team.late"), value: teamFollowUpList.filter(o => o.statuses.includes("Late")).length, color: "#F79009", bg: "#FEF3C7", icon: <ClockCircleFilled /> },
            { key: "absent", statusValue: "Absent", label: t("home.team.absent"), value: teamFollowUpList.filter(o => o.statuses.includes("Absent")).length, color: "#F04438", bg: "#FEE4E2", icon: <UserOutlined /> },
            { key: "notClockedIn", statusValue: "NotClockedIn", label: t("home.team.not-clocked-in"), value: teamFollowUpList.filter(o => o.statuses.includes("NotClockedIn")).length, color: "#667085", bg: "#F2F4F7", icon: <ClockCircleFilled /> },
        ];
        return (
            <Flex vertical gap={6} style={{ height: "100%" }}>
                {teamAllModal()}
                {teamStatusModal()}
                <Row gutter={[6, 6]}>{stats.map(teamStatItem)}</Row>
                <span style={{ fontWeight: 600, fontSize: 12.5 }}>{t("home.team.follow-up")}</span>
                <List
                    size="small"
                    className={styles.compactList}
                    dataSource={teamRecentList.slice(0, 3)}
                    renderItem={renderFollowUpItem}
                />
                <Flex justify="center" align="center" gap={4}>
                    <span style={{ color: "#009DE6", cursor: "pointer", fontSize: 12 }} onClick={() => setTeamModalOpen(true)}>
                        {t('home.btn.view-all-team')} <RightOutlined style={{ fontSize: 10 }} />
                    </span>
                </Flex>
            </Flex>
        );
    }, [teamAllList, teamFollowUpList, teamRecentList, computedLeaveToday, teamAllModal, teamStatusModal, t]);



    const { teamVisaWorkPermit } = useSelector((state) => state.employee);
    const getTeamVisaWorkPermit = useCallback(async () => {
        try {
            const apiCall = isHr ? getCompanyVisaWorkPermitInfo : getSubOrdinateVisaWorkPermitInfo;
            const res = await apiCall({
                requestId: generateRandomString(),
                companyId: currentCompany,
                employeeId: currentEmployee,
            });
            dispatch(setTeamVisaWorkPermit(res?.data?.visaWorkPermitEnt || []));
        } catch (error) {
            // silent fail, keep empty list in UI
        }
    }, [currentCompany, currentEmployee, isHr, dispatch]);

    useEffect(() => {
        if (currentCompany && currentEmployee && roles.includes("ACCESS_HOME")) {
            getTeamWorkingCount();
            getTeamWorkingDetail();
            if (isHr) {
                getTeamVisaWorkPermit();
            }
        }
    }, [currentCompany, currentEmployee, roles, isHr, getTeamWorkingCount, getTeamWorkingDetail, getTeamVisaWorkPermit]);

    const visaUrgencyMeta = {
        red: { bg: "#FEE4E2", fg: "#F04438" },
        orange: { bg: "#FEF3C7", fg: "#F79009" },
        green: { bg: "#ECFDF3", fg: "#12B76A" },
    };
    const getExpiryUrgency = (daysLeft) => {
        if (daysLeft == null) return "green";
        if (daysLeft <= 30) return "red";
        if (daysLeft <= 60) return "orange";
        return "green";
    };
    const [visaSegment, setVisaSegment] = useState("visa");
    const visaPermit = useMemo(() => {
        const language = i18n.language === "en" ? "En" : "";

        const buildEntry = (o, expireDate, type, category) => {
            const expire = expireDate ? dayjs(expireDate) : null;
            const daysLeft = expire ? expire.startOf('day').diff(dayjs().startOf('day'), "day") : null;
            const urgency = getExpiryUrgency(daysLeft);
            const statusLabel = daysLeft == null
                ? "-"
                : daysLeft <= 0
                    ? t("home.visa.expired")
                    : urgency === "green"
                        ? t("home.visa.not-near-expire")
                        : t("home.visa.expire-in-days", { days: daysLeft });

            return {
                id: `${o.id}-${category}`,
                name: `${o["name" + language] ?? ""} ${o["surName" + language] ?? ""}`.trim(),
                type,
                category,
                statusLabel,
                expireDate: expire
                    ? expire.format(i18n.language === "en" ? "DD MMM YYYY" : "DD MMM BBBB")
                    : "-",
                urgency,
                daysLeft,
                avatar: null,
            };
        };

        const mapped = (teamVisaWorkPermit || []).flatMap((o) => {
            const entries = [];

            if (o.visaExpireDate) {
                const visaType = o.visaInfo?.["visaName" + language] || o.visaInfo?.visaNameEn || "Visa";
                entries.push(buildEntry(o, o.visaExpireDate, visaType, "visa"));
            }

            if (o.workPermitExpireDate) {
                entries.push(buildEntry(o, o.workPermitExpireDate, "Work Permit", "workPermit"));
            }

            return entries;
        });

        return mapped.sort((a, b) => {
            if (a.daysLeft == null) return 1;
            if (b.daysLeft == null) return -1;
            return a.daysLeft - b.daysLeft;
        });
    }, [teamVisaWorkPermit, i18n.language, t]);

    const visaPermitFiltered = useMemo(
        () => visaPermit.filter((item) => item.category === visaSegment),
        [visaPermit, visaSegment]
    );

    const getVisaPermitSegmentedExtra = useCallback(() => (
        <Segmented
            className={styles.customSegmented}
            options={[
                { label: t('home.visa.tab.visa'), value: 'visa' },
                { label: t('home.visa.tab.work-permit'), value: 'workPermit' },
            ]}
            value={visaSegment}
            onChange={setVisaSegment}
        />
    ), [visaSegment, t]);

    const getVisaPermit = useCallback(() => (
        <List
            size="small"
            className={styles.compactList}
            dataSource={visaPermitFiltered}
            renderItem={item => {
                const meta = visaUrgencyMeta[item.urgency] ?? visaUrgencyMeta.green;
                return (
                    <List.Item style={{ padding: "10px 0" }}>
                        <Flex align="center" justify="space-between" style={{ width: "100%" }}>
                            <Flex align="center" gap={10}>
                                <Avatar size={36} src={item.avatar} icon={!item.avatar && <UserOutlined />} />
                                <Flex vertical gap={0}>
                                    <span style={{ fontWeight: 600, fontSize: 13 }}>{item.name}</span>
                                    <span style={{ fontSize: 12, color: "#667085" }}>{item.type}</span>
                                </Flex>
                            </Flex>
                            <Flex vertical align="end" gap={4}>
                                <span
                                    style={{
                                        fontSize: 11,
                                        fontWeight: 600,
                                        lineHeight: "20px",
                                        padding: "2px 10px",
                                        borderRadius: 999,
                                        backgroundColor: meta.bg,
                                        color: meta.fg,
                                        whiteSpace: "nowrap",
                                    }}
                                >
                                    {item.statusLabel}
                                </span>
                                <span style={{ fontSize: 12, color: "#667085", whiteSpace: "nowrap" }}>
                                    {item.expireDate}
                                </span>
                            </Flex>
                        </Flex>
                    </List.Item>
                );
            }}
        />
    ), [visaPermitFiltered]);

    const dayRequestInfo = useMemo(() => {
        if (!selectedDetailDate) return [];
        const entry = workinCalendarHome?.find(item => item.date === selectedDetailDate.format("YYYY-MM-DD"));
        if (!entry) return [];

        const language = i18n.language === "en" ? "En" : "";
        const items = [];

        const formatLeaveDoc = (doc) => {
            const isFullDay = doc?.durationType === "ALLDAY" || doc?.durationType === "DAY";
            if (isFullDay) return null; // ลาทั้งวัน ไม่ต้องขึ้นแถว "คำขอ"

            const name = doc?.["leaveTypeName" + language];
            if (!name) return null;

            const start = doc?.startDate ? dayjs(doc.startDate).format("HH:mm") : null;
            const end = doc?.endDate ? dayjs(doc.endDate).format("HH:mm") : null;

            return start && end ? `${name} (${start} - ${end})` : name;
        };

        (entry?.leaveDocument ?? []).forEach(doc => {
            const text = formatLeaveDoc(doc);
            if (text) items.push(text);
        });

        (entry?.leaveDocumentPending ?? []).forEach(doc => {
            const text = formatLeaveDoc(doc);
            if (text) items.push(text);
        });

        if (entry?.offSiteWorkDocument && typeof entry.offSiteWorkDocument === "object") {
            const name = i18n.language === "en" ? entry.offSiteWorkDocument?.offSiteWorkGroupEn : entry.offSiteWorkDocument?.offSiteWorkGroup;
            if (name) items.push(name);
        }

        if (entry?.offSiteWorkDocumentPending && typeof entry.offSiteWorkDocumentPending === "object") {
            const name = i18n.language === "en" ? entry.offSiteWorkDocumentPending?.offSiteWorkGroupEn : entry.offSiteWorkDocumentPending?.offSiteWorkGroup;
            if (name) items.push(name);
        }

        return items;
    }, [workinCalendarHome, selectedDetailDate, i18n.language]);
    const getDayNoteEditor = useCallback(() => {
        if (!selectedDetailDate) return null;

        return (
            <Flex vertical gap={4} style={{ width: '100%' }}>
                <Input.TextArea
                    value={noteValue}
                    onChange={(e) => setNoteValue(e.target.value)}
                    placeholder={t('home.note.placeholder')}
                    disabled={noteLoading || noteSaving}
                    autoSize={{ minRows: 1, maxRows: 2 }}
                    className={styles.noteTextArea}
                    style={{ fontSize: 12, resize: "none" }}
                />

                <Flex justify="end" gap={6}>
                    <Button
                        size="small"
                        onClick={onCancelNote}
                        disabled={!isNoteDirty || noteSaving}
                        style={{ borderRadius: 6, fontSize: 11, height: 22, padding: "0 8px" }}
                    >
                        {t('common.cancel')}
                    </Button>
                    <Button
                        size="small"
                        type={isNoteDirty ? "primary" : "default"}
                        onClick={onConfirmNote}
                        loading={noteSaving}
                        disabled={!isNoteDirty}
                        style={{
                            borderRadius: 6,
                            fontSize: 11,
                            height: 22,
                            padding: "0 8px",
                            backgroundColor: isNoteDirty ? 'var(--button-color)' : undefined,
                            color: isNoteDirty ? undefined : '#00000040',
                            borderColor: isNoteDirty ? undefined : '#d9d9d9',
                        }}
                    >
                        {t('common.confirm')}
                    </Button>
                </Flex>
            </Flex>
        );
    }, [selectedDetailDate, noteValue, noteLoading, noteSaving, isNoteDirty, onCancelNote, onConfirmNote, t]);

    const STATUS_COLOR_MAP = {
        normal: { dot: "#00BA34", bg: "#E6F9EB", fg: "#00BA34" }, // เข้าทำงานปกติ
        late: { dot: "#FF9F2D", bg: "#FFF5E9", fg: "#FF9F2D" }, // เข้างานสาย/กลับก่อน
        early: { dot: "#FF9F2D", bg: "#FFF5E9", fg: "#FF9F2D" }, // ออกก่อนเวลา (same bucket)
        absent: { dot: "#E92C2C", bg: "#FFECEC", fg: "#E92C2C" }, // ขาดงาน
        dayOff: { dot: "#585757", bg: "#E8E8E8", fg: "#585757" }, // วันหยุดตามกะ
        leave: { dot: "#E74AAB", bg: "#FADBEE", fg: "#E74AAB" }, // คำขอลางาน
        otHoliday: { dot: "#6A51C1", bg: "#E1DCF3", fg: "#6A51C1" }, // ทำงานล่วงเวลาในวันหยุด
        workShift: { dot: "#0085FF", bg: "#E6F3FF", fg: "#0085FF" }, // กะการทำงาน (fallback/default)
        pending: { dot: "#FFC107", bg: "#FFF8E1", fg: "#FFC107" }, // คำขอที่รออนุมัติ — confirm hex
    };

    const getStatusColorMeta = (entry) => {
        const statusEn = entry?.statusEn?.toLowerCase() ?? "";
        if (entry?.holidayName || statusEn === "day off") return STATUS_COLOR_MAP.dayOff;
        if (statusEn === "absent") return STATUS_COLOR_MAP.absent;
        if (statusEn.includes("late") && statusEn.includes("early")) return STATUS_COLOR_MAP.late;
        if (statusEn.includes("late")) return STATUS_COLOR_MAP.late;
        if (statusEn.includes("early")) return STATUS_COLOR_MAP.early;
        if (statusEn.includes("leave")) return STATUS_COLOR_MAP.leave;
        if (statusEn.includes("ot") && statusEn.includes("holiday")) return STATUS_COLOR_MAP.otHoliday;
        if (statusEn === "normal") return STATUS_COLOR_MAP.normal;
        if (statusEn === "pending") return STATUS_COLOR_MAP.pending;
        return STATUS_COLOR_MAP.workShift;
    };
    const REQUEST_BUTTON_BOTTOM_OFFSET = 10;
    const getSelectedDayDetail = useCallback(() => {
        if (!selectedDetailDate) {
            return null;
        }

        const entry = workinCalendarHome?.find(item => item.date === selectedDetailDate.format("YYYY-MM-DD"));
        const statusLabel = i18n.language === "en" ? (entry?.statusEn ?? "-") : (entry?.status ?? "-");
        const statusColor = getStatusColorMeta(entry);

        const dropdownItems = [
            {
                key: "leave",
                label: (
                    <Flex align="center" gap={10} style={{ padding: "4px 2px" }}>
                        <Flex align="center" justify="center" style={{ width: 28, height: 28, borderRadius: "50%", backgroundColor: "#ffdddb", color: "#FF4136", fontSize: 14, flexShrink: 0 }}>
                            <CalendarOutlined />
                        </Flex>
                        <Flex vertical gap={0}>
                            <span style={{ fontWeight: 600, fontSize: 12.5 }}>{t("calendar.label.leave_request")}</span>
                            <span style={{ fontSize: 11, color: "#98A2B3" }}>
                                {t("calendar.label.leave_of_date", {
                                    date: selectedDetailDate
                                        .locale(i18n.language === "en" ? "en" : "th")
                                        .format(i18n.language === "en" ? "D MMM YYYY" : "D MMM BBBB")
                                })}
                            </span>
                        </Flex>
                    </Flex>
                ),
                onClick: () => openRequestModal("leave"),
            },
            {
                key: "ot",
                label: (
                    <Flex align="center" gap={10} style={{ padding: "4px 2px" }}>
                        <Flex align="center" justify="center" style={{ width: 28, height: 28, borderRadius: "50%", backgroundColor: "#D1FAE5", color: "#12B76A", fontSize: 14, flexShrink: 0 }}>
                            <ClockCircleOutlined />
                        </Flex>
                        <Flex vertical gap={0}>
                            <span style={{ fontWeight: 600, fontSize: 12.5 }}>{t("employment-information.label.ot_request")}</span>
                            <span style={{ fontSize: 11, color: "#98A2B3" }}>
                                {t("calendar.label.leave_of_date", {
                                    date: selectedDetailDate
                                        .locale(i18n.language === "en" ? "en" : "th")
                                        .format(i18n.language === "en" ? "D MMM YYYY" : "D MMM BBBB")
                                })}
                            </span>
                        </Flex>
                    </Flex>
                ),
                onClick: () => openRequestModal("ot"),
            },
            {
                key: "offSite",
                label: (
                    <Flex align="center" gap={10} style={{ padding: "4px 2px" }}>
                        <Flex align="center" justify="center" style={{ width: 28, height: 28, borderRadius: "50%", backgroundColor: "#EDE9FE", color: "#7C3AED", fontSize: 14, flexShrink: 0 }}>
                            <EnvironmentOutlined />
                        </Flex>
                        <Flex vertical gap={0}>
                            <span style={{ fontWeight: 600, fontSize: 12.5 }}>{t("calendar.label.out_site_work_request")}</span>
                            <span style={{ fontSize: 11, color: "#98A2B3" }}>
                                {t("calendar.label.leave_of_date", {
                                    date: selectedDetailDate
                                        .locale(i18n.language === "en" ? "en" : "th")
                                        .format(i18n.language === "en" ? "D MMM YYYY" : "D MMM BBBB")
                                })}
                            </span>
                        </Flex>
                    </Flex>
                ),
                onClick: () => openRequestModal("offSite"),
            },
        ];

        return (
            <Flex vertical style={{ minHeight: 0, height: "100%" }}>
                <Flex justify="space-between" align="center" style={{ flexShrink: 0, marginBottom: 6 }}>
                    <span style={{ fontWeight: "bold", fontSize: 12 }}>
                        {selectedDetailDate.format(i18n.language === "en" ? "ddd D MMM YYYY" : "ddd D MMM BBBB")}
                    </span>
                    <Button
                        type="text"
                        size="small"
                        icon={<CloseOutlined />}
                        onClick={() => setSelectedDetailDate(null)}
                        style={{ padding: 2 }}
                    />
                </Flex>

                <Flex vertical gap={2} style={{ fontSize: 11, flexShrink: 0, marginBottom: 4 }}>
                    <span style={{ color: "#667085" }}>{t("units.status")}</span>
                    <div style={{ maxWidth: "100%", overflowX: "auto", scrollbarWidth: "none" }}>
                        <Flex
                            align="center"
                            gap={4}
                            style={{
                                display: "inline-flex",
                                backgroundColor: statusColor.bg,
                                color: statusColor.fg,
                                padding: "1px 8px",
                                borderRadius: 8,
                                fontSize: 10,
                                whiteSpace: "nowrap",
                            }}
                        >
                            <span style={{ width: 5, height: 5, borderRadius: "50%", backgroundColor: statusColor.dot, flexShrink: 0 }} />
                            {statusLabel}
                        </Flex>
                    </div>
                </Flex>

                <Flex vertical gap={0} style={{ flexShrink: 0, marginBottom: 3 }}>
                    <span style={{ color: "#667085", fontSize: 11 }}>{t("home.check-in")}</span>
                    <span style={{ fontSize: 12, fontWeight: 500, color: "var(--button-color)" }}>
                        {entry?.checkInTime ? dayjs(entry.checkInTime).format("HH:mm") : "-"}
                    </span>
                </Flex>

                <Flex vertical gap={0} style={{ flexShrink: 0, marginBottom: 4 }}>
                    <span style={{ color: "#667085", fontSize: 11 }}>{t("home.check-out")}</span>
                    <span style={{ fontSize: 12, fontWeight: 500, color: "var(--button-color)" }}>
                        {entry?.checkOutTime ? dayjs(entry.checkOutTime).format("HH:mm") : "-"}
                    </span>
                </Flex>

                {dayRequestInfo.length > 0 && (
                    <Flex vertical gap={0} style={{ flexShrink: 0, marginBottom: 4 }}>
                        <span style={{ color: "#667085", fontSize: 11 }}>{t("home.request")}</span>
                        <span style={{ fontSize: 10.5, fontWeight: 500, lineHeight: 1.25, color: "#42526D" }}>
                            {dayRequestInfo.join(` ${t("common.and")} `)}
                        </span>
                    </Flex>
                )}

                <Dropdown
                    menu={{ items: dropdownItems.map(({ onClick, ...rest }) => rest), onClick: ({ key }) => dropdownItems.find(i => i.key === key)?.onClick() }}
                    trigger={["click"]}
                    placement="bottomLeft"
                >
                    <button
                        style={{
                            flexShrink: 0,
                            alignSelf: "center",
                            width: "fit-content",
                            marginTop: "auto",
                            marginBottom: REQUEST_BUTTON_BOTTOM_OFFSET,
                            padding: "8px 18px",
                            backgroundColor: "#F5F8FF",
                            color: "#3B82F6",
                            fontWeight: 600,
                            fontSize: 12,
                            border: "1px solid #D6E4FF",
                            borderRadius: 999,
                            cursor: "pointer",
                            transition: "background-color 0.15s ease",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: 14,
                            whiteSpace: "nowrap",
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#E8EFFF"}
                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "#F5F8FF"}
                    >
                        <PlusOutlined style={{ fontSize: 10 }} />
                        <span>{t("home.btn.view-leave")}</span>
                        <DownOutlined style={{ fontSize: 9 }} />
                    </button>
                </Dropdown>
            </Flex>
        );
    }, [workinCalendarHome, selectedDetailDate, i18n.language, t, setIsRequestModalOpen, dayRequestInfo]);

    return {
        getCalendar,
        getCardInfo,
        getAnnouncement,
        getAnnouncementGrid,
        getTxnTime,
        getPolicyAnnouncement,
        isTabletOrMobile,
        getGreeting,
        getTodayWorkSummary,
        getQuickActions,
        getVisaPermit,
        getTeamToday,
        getTeamTotal,
        getSelectedDayDetail,
        selectedDetailDate,
        dayRequestModal,
        getVisaPermitSegmentedExtra,
        getNewsAndPolicyList,
        getDayNoteEditor,
        dynamicCalendarScale,
        needsSixthRow,
        getShiftSummary,
        isHr,
    };
}
export default useCardInfo;